

type OptionProps = {
    onChangeValue: (opcionElegida: any) => void;
  };
  const optionsList = [
    { value: "Seleccione el rubro al que se dedica su comercio", key: "" },
    { value: "ACADEMIAS DE CONDUCCIÓN", key: "ACADEMIAS DE CONDUCCIÓN" },
    { value: "ACCESORIOS", key: "ACCESORIOS" },
    { value: "ACUARIOS", key: "ACUARIOS" },
    { value: "ALBERGUES TRANSITORIOS", key: "ALBERGUES TRANSITORIOS" },
    { value: "ALMACENES", key: "ALMACENES" },
    { value: "ALQUILER DE PRENDAS", key: "ALQUILER DE PRENDAS" },
    { value: "ARMERÍA", key: "ARMERÍA" },
    { value: "ARTÍCULOS COMESTIBLES", key: "ARTÍCULOS COMESTIBLES" },
    { value: "ARTÍCULOS DE INFORMÁTICA", key: "ARTÍCULOS DE INFORMÁTICA" },
    { value: "ARTÍCULOS DE LIMPIEZA", key: "ARTÍCULOS DE LIMPIEZA" },
    { value: "ARTÍCULOS DEPORTIVOS", key: "ARTÍCULOS DEPORTIVOS" },
    { value: "ARTÍCULOS ELÉCTRICOS", key: "ARTÍCULOS ELÉCTRICOS" },
    { value: "ARTÍCULOS PARA EL HOGAR", key: "ARTÍCULOS PARA EL HOGAR" },
    { value: "ARTÍCULOS PARA PISCINAS", key: "ARTÍCULOS PARA PISCINAS" },
    { value: "ARTÍCULOS PROFESIONALES", key: "ARTÍCULOS PROFESIONALES" },
    { value: "ARTÍCULOS REGIONALES", key: "ARTÍCULOS REGIONALES" },
    { value: "ASOCIACIONES CIVÍLES", key: "ASOCIACIONES CIVÍLES" },
    { value: "AUXILIOS MECÁNICOS", key: "AUXILIOS MECÁNICOS" },
    { value: "BALNEARIOS", key: "BALNEARIOS" },
    { value: "BAR", key: "BAR" },
    { value: "BAZAR", key: "BAZAR" },
    { value: "BELLEZA GRAL", key: "BELLEZA GRAL" },
    { value: "BICICLETAS", key: "BICICLETAS" },
    { value: "BIJOUTERIE", key: "BIJOUTERIE" },
    { value: "BOMBONERÍAS", key: "BOMBONERÍAS" },
    { value: "BOUTIQUE", key: "BOUTIQUE" },
    { value: "CALZADOS", key: "CALZADOS" },
    { value: "CAMPINGS", key: "CAMPINGS" },
    { value: "CARNICERÍAS", key: "CARNICERÍAS" },
    { value: "CARPINTERÍA", key: "CARPINTERÍA" },
    { value: "CASA VELATORIA", key: "CASA VELATORIA" },
    { value: "CAZA", key: "CAZA" },
    { value: "CELULARES", key: "CELULARES" },
    { value: "CEMENTERIOS", key: "CEMENTERIOS" },
    { value: "CENTROS DE ESTÉTICA", key: "CENTROS DE ESTÉTICA" },
    { value: "CERRAJERÍA", key: "CERRAJERÍA" },
    { value: "CERVEZAS", key: "CERVEZAS" },
    { value: "CINES", key: "CINES" },
    { value: "CLUBES", key: "CLUBES" },
    { value: "COMBUSTIBLE", key: "COMBUSTIBLE" },
    { value: "COMIDA PARA LLEVAR", key: "COMIDA PARA LLEVAR" },
    { value: "CONFITERÍAS", key: "CONFITERÍAS" },
    { value: "COSER", key: "COSER" },
    { value: "COTILLÓN", key: "COTILLÓN" },
    { value: "CRISTALES", key: "CRISTALES" },
    { value: "DEBITO AUTOMÁTICO", key: "DEBITO AUTOMÁTICO" },
    { value: "DESPENSAS", key: "DESPENSAS" },
    { value: "DIARIOS", key: "DIARIOS" },
    { value: "DIETÉTICAS", key: "DIETÉTICAS" },
    { value: "DISTRIBUCIÓN DE GAS", key: "DISTRIBUCIÓN DE GAS" },
    { value: "DISTRIBUIDORES", key: "DISTRIBUIDORES" },
    { value: "E-COMMERCE", key: "E-COMMERCE" },
    { value: "ELECTRODOMÉSTICOS", key: "ELECTRODOMÉSTICOS" },
    { value: "ENTE GUBERNAMENTAL", key: "ENTE GUBERNAMENTAL" },
    { value: "ENTES MUNICIPALES", key: "ENTES MUNICIPALES" },
    { value: "ENTRETENIMIENTO", key: "ENTRETENIMIENTO" },
    { value: "ESTACIONAMIENTOS", key: "ESTACIONAMIENTOS" },
    { value: "ESTACIONES DE SERVICIO", key: "ESTACIONES DE SERVICIO" },
    { value: "EVENTOS", key: "EVENTOS" },
    { value: "FÁBRICA DE PASTAS", key: "FÁBRICA DE PASTAS" },
    { value: "FABRICANTES", key: "FABRICANTES" },
    { value: "FARMACIAS", key: "FARMACIAS" },
    { value: "FAST FOOD", key: "FAST FOOD" },
    { value: "FERRETERÍAS", key: "FERRETERÍAS" },
    { value: "FLORERÍAS", key: "FLORERÍAS" },
    { value: "FOTOGRAFÍA", key: "FOTOGRAFÍA" },
    { value: "FRUTERÍAS", key: "FRUTERÍAS" },
    { value: "FUNDACIONES", key: "FUNDACIONES" },
    { value: "GARRAFAS", key: "GARRAFAS" },
    { value: "GIMNASIOS", key: "GIMNASIOS" },
    { value: "GOMERÍAS", key: "GOMERÍAS" },
    { value: "GRANJAS", key: "GRANJAS" },
    { value: "GUARDIA", key: "GUARDIA" },
    { value: "HELADERÍA", key: "HELADERÍA" },
    { value: "HOBBIES", key: "HOBBIES" },
    { value: "HOSPITAL", key: "HOSPITAL" },
    { value: "HOTELES", key: "HOTELES" },
    { value: "ILUMINACIÓN", key: "ILUMINACIÓN" },
    { value: "IMPRENTAS", key: "IMPRENTAS" },
    { value: "INDUMENTARIA", key: "INDUMENTARIA" },
    { value: "INMOBILIARÍAS", key: "INMOBILIARÍAS" },
    { value: "INSTITUCIONES EDUCATIVAS", key: "INSTITUCIONES EDUCATIVAS" },
    { value: "INSTITUTOS DE ENSEÑANZA", key: "INSTITUTOS DE ENSEÑANZA" },
    { value: "INSTRUMENTOS MUSICALES", key: "INSTRUMENTOS MUSICALES" },
    { value: "INSUMOS PARA TEJER", key: "INSUMOS PARA TEJER" },
    { value: "JOYERÍAS", key: "JOYERÍAS" },
    { value: "JUEGOS DE AZAR", key: "JUEGOS DE AZAR" },
    { value: "JUGUETERÍAS", key: "JUGUETERÍAS" },
    { value: "KIOSKO", key: "KIOSKO" },
    { value: "LABORATORIOS", key: "LABORATORIOS" },
    { value: "LAVADEROS", key: "LAVADEROS" },
    { value: "LAVANDERÍA", key: "LAVANDERÍA" },
    { value: "LENCERÍA", key: "LENCERÍA" },
    { value: "LIBRERÍAS", key: "LIBRERÍAS" },
    { value: "LICORES", key: "LICORES" },
    { value: "LOTERÍAS", key: "LOTERÍAS" },
    { value: "LUBRICENTROS", key: "LUBRICENTROS" },
    { value: "MÁQUINAS", key: "MÁQUINAS" },
    { value: "MARROQUINERÍAS", key: "MARROQUINERÍAS" },
    { value: "MATERIALES PARA LA CONSTRUCCIÓN", key: "MATERIALES PARA LA CONSTRUCCIÓN" },
    { value: "MAYORISTAS", key: "MAYORISTAS" },
    { value: "MEDICINA", key: "MEDICINA" },
    { value: "MEDICINA PREPAGA", key: "MEDICINA PREPAGA" },
    { value: "MERCADO CENTRAL", key: "MERCADO CENTRAL" },
    { value: "MUEBLERÍAS", key: "MUEBLERÍAS" },
    { value: "NATATORIOS", key: "NATATORIOS" },
    { value: "OBRAS SOCIALES", key: "OBRAS SOCIALES" },
    { value: "ÓPTICAS", key: "ÓPTICAS" },
    { value: "ORTOPEDIAS", key: "ORTOPEDIAS" },
    { value: "OTROS", key: "OTROS" },
    { value: "PAGO DE SERVICIOS", key: "PAGO DE SERVICIOS" },
    { value: "PANADERÍA", key: "PANADERÍA" },
    { value: "PAÑALERA", key: "PAÑALERA" },
    { value: "PELUCAS Y POSTIZOS", key: "PELUCAS Y POSTIZOS" },
    { value: "PELUQUERÍAS", key: "PELUQUERÍAS" },
    { value: "PERFUMERÍAS", key: "PERFUMERÍAS" },
    { value: "PESCA", key: "PESCA" },
    { value: "PESCADERÍAS", key: "PESCADERÍAS" },
    { value: "PINTURERÍAS", key: "PINTURERÍAS" },
    { value: "PLANES DE AHORRO", key: "PLANES DE AHORRO" },
    { value: "PLATERÍA", key: "PLATERÍA" },
    { value: "POLIRUBRO", key: "POLIRUBRO" },
    { value: "PUB", key: "PUB" },
    { value: "QUINIELAS", key: "QUINIELAS" },
    { value: "RECREACIÓN", key: "RECREACIÓN" },
    { value: "REGALERÍA", key: "REGALERÍA" },
    { value: "RELOJERÍAS", key: "RELOJERÍAS" },
    { value: "REMISES", key: "REMISES" },
    { value: "REPOSTERIA", key: "REPOSTERIA" },
    { value: "REPUESTOS", key: "REPUESTOS" },
    { value: "RESTAURANTES", key: "RESTAURANTES" },
    { value: "REVISTAS", key: "REVISTAS" },
    { value: "RODADOS", key: "RODADOS" },
    { value: "ROTISERÍAS", key: "ROTISERÍAS" },
    { value: "SANTERÍAS", key: "SANTERÍAS" },
    { value: "SEGUROS", key: "SEGUROS" },
    { value: "SERVICIO DE LUNCH", key: "SERVICIO DE LUNCH" },
    { value: "SERVICIOS DE SALUD", key: "SERVICIOS DE SALUD" },
    { value: "SERVICIOS DE TRANSPORTE", key: "SERVICIOS DE TRANSPORTE" },
    { value: "SERVICIOS FINANCIEROS", key: "SERVICIOS FINANCIEROS" },
    { value: "SERVICIOS PARA EL AUTOMOTOR", key: "SERVICIOS PARA EL AUTOMOTOR" },
    { value: "SERVICIOS PROFESIONALES", key: "SERVICIOS PROFESIONALES" },
    { value: "SERVICIOS PÚBLICOS", key: "SERVICIOS PÚBLICOS" },
    { value: "SPA", key: "SPA" },
    { value: "SUPERMERCADOS", key: "SUPERMERCADOS" },
    { value: "TABAQUERÍA", key: "TABAQUERÍA" },
    { value: "TALLERES MECÁNICOS", key: "TALLERES MECÁNICOS" },
    { value: "TAXIS", key: "TAXIS" },
    { value: "TEATROS", key: "TEATROS" },
    { value: "TELEFONÍA", key: "TELEFONÍA" },
    { value: "TELEVISIÓN POR CABLE", key: "TELEVISIÓN POR CABLE" },
    { value: "TEXTIL", key: "TEXTIL" },
    { value: "TINTORERÍA", key: "TINTORERÍA" },
    { value: "TURISMO", key: "TURISMO" },
    { value: "UNIFORMES", key: "UNIFORMES" },
    { value: "VENTA DE ARTÍCULOS DEPORTIVOS", key: "VENTA DE ARTÍCULOS DEPORTIVOS" },
    { value: "VENTA DE MOTOS", key: "VENTA DE MOTOS" },
    { value: "VENTA DE PRODUCTOS AGRO", key: "VENTA DE PRODUCTOS AGRO" },
    { value: "VENTA POR CATÁLOGO", key: "VENTA POR CATÁLOGO" },
    { value: "VENTA TELEFÓNICA", key: "VENTA TELEFÓNICA" },
    { value: "VENTAS DE AUTOMOTORES", key: "VENTAS DE AUTOMOTORES" },
    { value: "VERDULERÍAS", key: "VERDULERÍAS" },
    { value: "VETERINARIA", key: "VETERINARIA" },
    { value: "VINOTECAS", key: "VINOTECAS" },
    { value: "VIVEROS", key: "VIVEROS" },
  ];
  
  const RubrosOption: React.FC<OptionProps> = ({ onChangeValue }: OptionProps) => {
  
    return (
      <select name={"rubro"} tabIndex={0} aria-label={"Seleccione rubro al que se dedica su comercio"} style={{width:"100%"}} onChange={(e): void => onChangeValue(e.currentTarget.selectedOptions[0].value===""?null:e.currentTarget.selectedOptions[0].value)}>{
        optionsList.map((opt) =>
          <option value={opt.key} key={opt.key}>{opt.value}</option>)
      }
      </select>
    );
  };
  export default RubrosOption;
  